<template>
  <el-dialog :title="$t('user86')" :close-on-click-modal="false" :close-on-press-escape="false"
    :visible.sync="dialog.edit" width="25%" class="info-dialog">
    <el-form :model="formData" :rules="rules" ref="formData" class="form-data">
      <el-form-item label="开户人">
        <template slot="label">
          <I18Lang id="user61" defaultText="开户人" />
        </template>
        <el-input :disabled="!!userInfo.bank_info.bank_name && userInfo.auth_status === 2" v-model="formData.bank_user"
          :placeholder="$t('user66')"></el-input>
      </el-form-item>
      <el-form-item prop="bank_name" label="银行名称">
        <template slot="label">
          <I18Lang id="user62" defaultText="银行名称" />
        </template>
        <el-input v-model="formData.bank_name" :placeholder="$t('user67')"></el-input>
      </el-form-item>
      <el-form-item prop="bank_no" label="卡号">
        <template slot="label">
          <I18Lang id="user63" defaultText="卡号" />
        </template>
        <el-input v-model="formData.bank_no" :placeholder="$t('user68')"></el-input>
      </el-form-item>
      <el-form-item label="Swift Code">
        <el-input v-model="formData.swift_code" :placeholder="$t('public31')"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <div class="btn kg-btn2" type="primary" @click="submitForm('formData')">
        <I18Lang id="user84" defaultText="提交" />
      </div>
    </div>
  </el-dialog>
</template>

<script>

import { mapState } from 'vuex'
export default {
  name: 'record',
  data () {
    return {
      dialog: {
        edit: false
      },
      formData: {
        bank_name: '',
        bank_no: '',
        bank_user: '',
        swift_code: ''
      },
      rules: {
        bank_name: [{ required: true, message: this.$t('public20'), trigger: 'blur' }],
        bank_no: [{ required: true, message: this.$t('public20'), trigger: 'blur' }]
      }
    }
  },
  methods: {
    showDialog () { // 修改类型
      this.dialog.edit = true
      if (this.userInfo.bank_info) {
        this.formData.bank_name = this.userInfo.bank_info.bank_name
        this.formData.bank_no = this.userInfo.bank_info.bank_no
        this.formData.bank_user = this.userInfo.bank_info.bank_user
        this.formData.swift_code = this.userInfo.bank_info.swift_code
      }
    },
    submitForm (formName) {
      this.isSubmitLoading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData()
        } else {
          this.isSubmitLoading = false
          console.log('error submit!!')
          return false
        }
      })
    },
    submitData () {
      this.$http.post('/api/user/editBankInfo', this.formData).then(result => {
        this.dialog.edit = false
        this.$emit('onUpdata')
        this.$alert(this.$t('public75'), {
          confirmButtonText: this.$t('my25'),
          center: true,
          customClass: 'success-alert',
          callback: action => {
          }
        })
      }).catch(() => {
        this.isSubmitLoading = false
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  },
  computed: {
    ...mapState(['userInfo'])
  }
}
</script>
<style scoped lang="scss">
@media only screen and (min-width: 756px) {
  .info-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #eeeeee;
    padding: 23px 0;

    &:last-child {
      border-bottom: none;
    }

    .key {
      font-size: 16px;
      color: #8c7f7e;
      letter-spacing: 0;
      line-height: 24px;
      width: 100px;
      display: inline-block;
    }

    .vl {
      font-size: 16px;
      color: #2a2a2a;
      letter-spacing: 0;
      line-height: 24px;
      display: inline-block;
    }

    .edit {
      font-size: 16px;
      color: #e61816;
      letter-spacing: 0;
      line-height: 24px;
      cursor: pointer;
    }
  }

  .account-info-dialog {
    .form-data {
      ::v-deep .el-form-item {
        margin-bottom: 10px;
      }

      ::v-deep .el-input__inner {}

      .get-code {
        ::v-deep .el-input__inner {
          border-right: none;
          border-color: #dcdfe6;
        }
      }

      ::v-deep .el-input-group__append {
        background: #fff;
        border-color: #dcdfe6;
        height: 48px;
      }

      .btn-send-code {
        background: #fff;
        font-size: 16px;
        color: #e61816;
        letter-spacing: 0;
      }
    }

    .info {
      font-size: 16px;
      color: #e61816;
    }

    .dialog-footer {
      font-size: 16px;
      color: #fff;
      letter-spacing: 0;
      text-align: center;
      line-height: 24px;

      .submit {
        font-size: 16px;
        background: #e61816;
        border-color: #e61816;
        letter-spacing: 0;
        width: 100%;
        text-align: center;
      }
    }
  }

  .bank-card {
    background: #f4f5f7;
    border-radius: 9px;
    border-radius: 9px;
    padding: 32px;

    .top {
      display: flex;
      align-items: center;

      .bank-logo {
        width: 48px;
        height: 48px;
        margin-right: 24px;
      }

      .bank-name {
        font-size: 20px;
        color: #2a2a2a;
        letter-spacing: 0;
        line-height: 24px;
      }
    }

    .bank-address {
      font-size: 16px;
      color: #2a2a2a;
      letter-spacing: 0;
      line-height: 24px;
      margin-top: 15px;
    }

    .bank-number {
      font-size: 20px;
      color: #2a2a2a;
      letter-spacing: 0;
      line-height: 24px;
      margin-top: 8px;
    }
  }
}

@media only screen and (max-width: 755px) {
  .info-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #eeeeee;
    padding: 23px 0;

    &:last-child {
      border-bottom: none;
    }

    .key {
      font-size: 26px;
      color: #8c7f7e;
      letter-spacing: 0;
      line-height: 24px;
      width: 180px;
      display: inline-block;
    }

    .vl {
      font-size: 26px;
      color: #2a2a2a;
      letter-spacing: 0;
      line-height: 24px;
      display: inline-block;
    }

    .edit {
      font-size: 26px;
      color: #e61816;
      letter-spacing: 0;
      line-height: 24px;
      cursor: pointer;
    }
  }

  .account-info-dialog {
    ::v-deep .el-dialog__header {
      padding: 30px 30px 20px;

      .el-dialog__title {
        font-size: 26px;
      }

    }

    ::v-deep .el-dialog__body {
      padding: 10px 30px 0;
    }

    .form-data {
      ::v-deep .el-input__inner {
        height: 60px;
        line-height: 60px;
      }

      .get-code {
        ::v-deep .el-input__inner {
          border-right: none;
          border-color: #dcdfe6;
        }
      }

      ::v-deep .el-input-group__append {
        background: #fff;
        border-color: #dcdfe6;
        height: 60px;
      }

      ::v-deep .el-form-item__content {
        margin-left: 0;
      }

      .btn-send-code {
        background: #fff;
        font-size: 26px;
        color: #e61816;
        letter-spacing: 0;
      }
    }

    .info {
      font-size: 26px;
      color: #e61816;
    }

    .dialog-footer {
      font-size: 26px;
      color: #fff;
      letter-spacing: 0;
      text-align: center;
      line-height: 24px;

      .submit {
        font-size: 26px;
        height: 70px;
        background: #e61816;
        border-color: #e61816;
        letter-spacing: 0;
        width: 100%;
        text-align: center;
      }
    }
  }

  .bank-card {
    background: #f4f5f7;
    border-radius: 9px;
    border-radius: 9px;
    padding: 32px;

    .top {
      display: flex;
      align-items: center;

      .bank-logo {
        width: 48px;
        height: 48px;
        margin-right: 24px;
      }

      .bank-name {
        font-size: 22px;
        color: #2a2a2a;
        letter-spacing: 0;
        line-height: 24px;
      }
    }

    .bank-address {
      font-size: 22px;
      color: #2a2a2a;
      letter-spacing: 0;
      line-height: 24px;
      margin-top: 20px;
    }

    .bank-number {
      font-size: 22px;
      color: #2a2a2a;
      letter-spacing: 0;
      line-height: 24px;
      margin-top: 8px;
    }
  }
}
</style>
